import { StyledProps } from '@emotion/react';
import styled from '@emotion/styled';
import { useProgressContext } from '../../contexts/ProgressContext';
import { FC, PropsWithChildren } from 'react';
import { StoryWrapper } from './StoryWrapper';

interface Props extends PropsWithChildren {
    pageIndex: number;
}

const Wrapper = styled(StoryWrapper)<StyledProps<{ isVisible: boolean }>>`
    visibility: ${({ isVisible }) => (isVisible ? 'visible' : 'hidden')};
`;

export const CurrentStoryPageWrapper: FC<Props> = ({ children, pageIndex }) => {
    const { currentPageIndex } = useProgressContext();
    return (
        <Wrapper isVisible={pageIndex == currentPageIndex}>{children}</Wrapper>
    );
};
